import { DataGridPro, jaJP, type DataGridProProps } from "@mui/x-data-grid-pro";
import { type SxProps, type Theme } from "@mui/material";

import { HEADER_HEIGHT } from "@/features/header";

/**
 * DataGridのヘッダーを固定するための共通設定
 * HEADER_HEIGHT分だけ下にずれたところで固定されるようになります
 * @param stickyHeader trueならヘッダー固定用のsxが返す、falseなら{}を返す
 */
export const getStickyHeaderSx = (stickyHeader: boolean): SxProps<Theme> => {
  return stickyHeader
    ? {
        "& .MuiDataGrid-main": {
          overflow: "clip",
        },
        "& .MuiDataGrid-columnHeaders": {
          position: "sticky",
          top: HEADER_HEIGHT,
          zIndex: 11,
        },
        "& .MuiDataGrid-virtualScroller": {
          marginTop: "0 !important",
        },
      }
    : {};
};

// 不要であったり、不変にしたり等で外から受け取らないプロパティ
type OmitProperties = "autoHeight" | "density" | "localeText";

interface IProps extends Omit<DataGridProProps, OmitProperties> {
  stickyHeader?: boolean;
}

const DataGrid: React.FC<IProps> = ({ stickyHeader = false, ...props }) => {
  return (
    <DataGridPro
      autoHeight
      density="compact"
      localeText={{
        ...jaJP.components.MuiDataGrid.defaultProps.localeText,
        MuiTablePagination: {
          labelDisplayedRows: ({ from, to, count }) =>
            `${count.toLocaleString()}件中 ${from.toLocaleString()}件 〜 ${to.toLocaleString()}件`,
          labelRowsPerPage: "ページあたりの行数:",
        },
      }}
      loading={props.loading ?? false}
      disableSelectionOnClick={props.disableSelectionOnClick ?? false}
      pagination
      {...props}
      sx={[getStickyHeaderSx(stickyHeader), props.sx ?? {}] as SxProps<Theme>}
    />
  );
};

export { DataGrid };
